var map = {
	"./modules/admins/routes/Admins.routes.js": 6655,
	"./modules/auth/routes/Auth.routes.js": 1532,
	"./modules/auth/routes/Profile.routes.js": 2232,
	"./modules/career_aptitude_test_questions/routes/CareerAptitudeTestQuestions.routes.js": 2968,
	"./modules/ethical_advices/routes/EthicalAdvices.routes.js": 7253,
	"./modules/faqs/routes/faqs.routes.js": 3071,
	"./modules/home/routes/Home.routes.js": 2313,
	"./modules/job_fields/routes/JobFields.routes.js": 4537,
	"./modules/job_opportunities/routes/JobOpportunities.routes.js": 7618,
	"./modules/job_publishers/routes/JobPublishers.routes.js": 5285,
	"./modules/news/routes/News.routes.js": 8299,
	"./modules/platform_feedback/routes/PlatformFeedback.routes.js": 6841,
	"./modules/projects/routes/Projects.routes.js": 1734,
	"./modules/trainer_resumes/routes/TrainerResumes.routes.js": 5089,
	"./modules/training_program_appilication_questions/routes/TrainingProgramApplicationQuestions.routes.js": 6463,
	"./modules/training_program_applications/routes/TrainingProgramApplications.routes.js": 426,
	"./modules/training_program_suggestions/routes/TrainingProgramSuggestions.routes.js": 2,
	"./modules/training_programs/routes/TrainingPrograms.routes.js": 1008,
	"./modules/users/routes/Users.routes.js": 8964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4443;